import { render, staticRenderFns } from "./AdressePersonnelle.vue?vue&type=template&id=60ec12e5"
import script from "./AdressePersonnelle.vue?vue&type=script&lang=js"
export * from "./AdressePersonnelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports